const Analysis = ({ tableData = [] }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="px-2 py-2 border bg-white"></th>

            {/* Portfolio */}
            <th
              colSpan="5"
              className="px-2 py-2 border bg-[#D4EDFF] text-[12px] font-bold"
            >
              PORTFOLIO
            </th>

            {/* On Time */}
            <th
              colSpan="3"
              className="px-2 py-2 border bg-[#DEFFF4] text-[12px] font-bold"
            >
              ON TIME
            </th>

            {/* 1-30 */}
            <th
              colSpan="3"
              className="px-2 py-2 border bg-[#F3FFDE] text-[12px] font-bold"
            >
              1-30 Days
            </th>

            {/* 31-60 */}
            <th
              colSpan="3"
              className="px-2 py-2 border bg-[#FFF8DE] text-[12px] font-bold"
            >
              31-60 Days
            </th>

            {/* 61-90 */}
            <th
              colSpan="3"
              className="px-2 py-2 border bg-[#FFE7DE] text-[12px] font-bold"
            >
              61-90 Days
            </th>

            {/* 91-180 */}
            <th
              colSpan="3"
              className="px-2 py-2 border bg-[#FFDEDE] text-[12px] font-bold"
            >
              91-180 Days
            </th>

            {/* Over 180 */}
            <th
              colSpan="3"
              className="px-2 py-2 border bg-[#FBBBBB] text-[12px] font-bold"
            >
              Over 180 Days
            </th>
          </tr>

          {/* Sub Headers */}
          <tr>
            <th className="px-2 py-2 border text-left text-[10px]">
              LOAN OFFICER
            </th>

            {/* Portfolio */}
            <th className="px-2 py-2 border text-[10px]">NOL</th>
            <th className="px-2 py-2 border text-[10px]">P</th>
            <th className="px-2 py-2 border text-[10px]">I</th>
            <th className="px-2 py-2 border text-[10px]">TOTAL</th>
            <th className="px-2 py-2 border text-[10px]">#</th>

            {/* On Time */}
            <th className="px-2 py-2 border text-[10px]">Amount</th>
            <th className="px-2 py-2 border text-[10px]">%</th>
            <th className="px-2 py-2 border text-[10px]">#</th>

            {/* 1-30 */}
            <th className="px-2 py-2 border text-[10px]">Amount</th>
            <th className="px-2 py-2 border text-[10px]">%</th>
            <th className="px-2 py-2 border text-[10px]">#</th>

            {/* 31-60 */}
            <th className="px-2 py-2 border text-[10px]">Amount</th>
            <th className="px-2 py-2 border text-[10px]">%</th>
            <th className="px-2 py-2 border text-[10px]">#</th>

            {/* 61-90 */}
            <th className="px-2 py-2 border text-[10px]">Amount</th>
            <th className="px-2 py-2 border text-[10px]">%</th>
            <th className="px-2 py-2 border text-[10px]">#</th>

            {/* 91-180 */}
            <th className="px-2 py-2 border text-[10px]">Amount</th>
            <th className="px-2 py-2 border text-[10px]">%</th>
            <th className="px-2 py-2 border text-[10px]">#</th>

            {/* Over 180 */}
            <th className="px-2 py-2 border text-[10px]">Amount</th>
            <th className="px-2 py-2 border text-[10px]">%</th>
            <th className="px-2 py-2 border text-[10px]">#</th>
          </tr>
        </thead>

        <tbody>
          {tableData?.length === 0 ? (
            <tr>
              <td colSpan="23" className="text-center py-4">
                No data available
              </td>
            </tr>
          ) : (
            tableData?.map((data, idx) => (
              <tr key={idx}>
                <td className="px-2 py-2 border text-[10px]">
                  {data["LOAN OFFICER"] ?? "N/A"}
                </td>

                {/* Portfolio */}
                <td className="px-2 py-2 border text-[10px]">
                  {data?.NOL ?? "N/A"}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.P ?? "N/A"}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.I ?? "N/A"}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.TOTAL ?? "N/A"}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["TOTAL #"] ?? 0}
                </td>

                {/* On Time */}
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["ON TIME AMOUNT"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["ON TIME %"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["ON TIME #"]}
                </td>

                {/* 1-30 */}
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["1-30 AMOUNT"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["1-30 %"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["1-30 #"]}
                </td>

                {/* 31-60 */}
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["31-60 AMOUNT"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["31-60 %"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["31-60 #"]}
                </td>

                {/* 61-90 */}
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["61-90 AMOUNT"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["61-90 %"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["61-90 #"]}
                </td>

                {/* 91-180 */}
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["91-180 AMOUNT"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["91-180 %"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["91-180 #"]}
                </td>

                {/* Over 180 */}
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["OVER 180 AMOUNT"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["OVER 180 %"]}
                </td>
                <td className="px-2 py-2 border text-[10px]">
                  {data?.["OVER 180 #"]}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Analysis;
